import React, { FC } from 'react';
import cn from 'classnames';
import { SportEventState } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useStageBadgeText } from './useStageBadgeText';
import styles from './StageBadge.module.css';

interface StageBadgeProps {
    eventState: SportEventState;
    startTime: string;
    endTime: string;
    flat?: boolean;
}

export const StageBadge: FC<StageBadgeProps> = ({ eventState, startTime, endTime, flat }) => {
    const stageText = useStageBadgeText({
        eventState,
        startTime,
        endTime,
    });

    const isLive = eventState === 'LIVE';
    const isAnnounce = eventState === 'ANNOUNCE';

    const finalStyles = getStyles({
        live: isLive,
        announce: isAnnounce,
        flat,
    });

    return (
        <div className={finalStyles.root}>
            {isLive && <div className={finalStyles.dot} />}

            <span className={finalStyles.text}>{stageText}</span>
        </div>
    );
};

function getStyles(params: { live?: boolean; announce?: boolean; flat?: boolean }) {
    const { live, announce, flat } = params;
    let rootSecondStyle;
    let textSecondStyle;
    let dotSecondStyle;

    if (live) {
        rootSecondStyle = styles.liveRoot;
    } else if (announce) {
        textSecondStyle = styles.announceStageText;
        rootSecondStyle = styles.announceRoot;
    }

    if (flat) {
        textSecondStyle = undefined;
        rootSecondStyle = styles.rootFlat;
        dotSecondStyle = styles.liveDotIconFlat;
    }

    return {
        root: cn(styles.root, rootSecondStyle),
        text: cn(styles.stageText, textSecondStyle),
        dot: cn(styles.liveDotIcon, dotSecondStyle),
    };
}
